import { Button, Modal } from 'antd'
import React, { useState } from 'react'

const ConfirmationModal = ({ content, onClick }) => {
  const [open, setOpen] = useState(false)
  const showModal = () => setOpen(true)
  const closeModal = () => setOpen(false)

  return (
    <>
      <Button
        disabled={content?.mainButton?.disabled}
        loading={content?.mainButton?.loading}
        type='primary'
        className='action-bar-btn'
        onClick={showModal}
      >
        {content?.mainButton?.text}
      </Button>
      <Modal
        centered
        open={open}
        onCancel={closeModal}
        footer={null}
        closeIcon={false}
        className='player_interface_modals'
        closable={false}
      >
        <div className='close_modal_button' onClick={closeModal}>
          x
        </div>
        <div className='modal_body'>
          <div className='center_content release_player'>
            <h1 className='modal_header_heading'>{content?.title}</h1>
          </div>
          <div className='modal_footer'>
            <Button
              disabled={content?.submitButton?.disabled}
              loading={content?.submitButton?.loading}
              type='primary'
              className='button_1'
              onClick={onClick}
            >
              {content?.submitButton?.text}
            </Button>
            <Button onClick={closeModal} type='primary' className='button_2'>
              Cancel
            </Button>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default ConfirmationModal
